export function responseSuggestions(scenario, voice, sector) {
  const formal = voice !== 'du';

  if (sector === 'health') {
    if (scenario === 'positive' || scenario === 'positive_empty') {
      return formal
        ? [
            'Vielen Dank für Ihre Rückmeldung. Wir freuen uns, dass Sie sich Zeit für eine Bewertung genommen haben. Aus Rücksicht auf die Privatsphäre äußern wir uns hier nicht zu einzelnen Vorgängen.',
            'Danke für Ihre Bewertung. Wir wissen Ihre Rückmeldung zu schätzen. Wenn Sie uns etwas persönlich mitteilen möchten, erreichen Sie uns über [Kontaktweg].',
          ]
        : [
            'Vielen Dank für deine Rückmeldung. Wir freuen uns, dass du dir Zeit für eine Bewertung genommen hast. Aus Rücksicht auf die Privatsphäre äußern wir uns hier nicht zu einzelnen Vorgängen.',
            'Danke für deine Bewertung. Wir wissen deine Rückmeldung zu schätzen. Wenn du uns etwas persönlich mitteilen möchtest, erreichst du uns über [Kontaktweg].',
          ];
    }
    return formal
      ? [
          'Vielen Dank für Ihre Rückmeldung. Zu einzelnen Vorgängen können wir uns öffentlich nicht äußern. Bitte kontaktieren Sie uns unter [Kontaktweg]. Wir prüfen Ihr Anliegen gern vertraulich.',
          'Danke, dass Sie sich Zeit für eine Bewertung genommen haben. Wir möchten Ihr Anliegen verstehen, ohne persönliche Details öffentlich zu besprechen. Bitte kontaktieren Sie uns unter [Kontaktweg].',
        ]
      : [
          'Vielen Dank für deine Rückmeldung. Zu einzelnen Vorgängen können wir uns öffentlich nicht äußern. Bitte melde dich unter [Kontaktweg]. Wir prüfen dein Anliegen gern vertraulich.',
          'Danke, dass du dir Zeit für eine Bewertung genommen hast. Wir möchten dein Anliegen verstehen, ohne persönliche Details öffentlich zu besprechen. Bitte melde dich unter [Kontaktweg].',
        ];
  }

  if (scenario === 'mixed') {
    return formal
      ? [
          'Vielen Dank für Ihre differenzierte Rückmeldung. Wir freuen uns über das Lob und nehmen Ihre Kritik ernst. Wenn Sie den Vorgang persönlich besprechen möchten, erreichen Sie uns unter [Kontaktweg].',
          'Danke, dass Sie sowohl Positives als auch Verbesserungsbedarf angesprochen haben. Wir lesen Ihre Hinweise aufmerksam und prüfen den geschilderten Punkt intern. Gern sprechen wir unter [Kontaktweg] persönlich darüber.',
        ]
      : [
          'Vielen Dank für deine differenzierte Rückmeldung. Wir freuen uns über das Lob und nehmen deine Kritik ernst. Wenn du den Vorgang persönlich besprechen möchtest, erreichst du uns unter [Kontaktweg].',
          'Danke, dass du sowohl Positives als auch Verbesserungsbedarf angesprochen hast. Wir lesen deine Hinweise aufmerksam und prüfen den geschilderten Punkt intern. Gern sprechen wir unter [Kontaktweg] persönlich darüber.',
        ];
  }

  if (scenario === 'critical' || scenario === 'critical_empty') {
    return formal
      ? [
          'Vielen Dank für Ihre Rückmeldung. Wir bedauern, dass Ihr Eindruck nicht Ihren Erwartungen entspricht. Wir möchten Ihr Anliegen besser verstehen. Bitte kontaktieren Sie uns unter [Kontaktweg], damit wir es vertraulich besprechen können.',
          'Danke, dass Sie sich Zeit für eine Bewertung genommen haben. Wir nehmen Ihre Kritik ernst und würden den Vorgang gern nachvollziehen. Unter [Kontaktweg] erreichen Sie uns für ein persönliches Gespräch.',
        ]
      : [
          'Vielen Dank für deine Rückmeldung. Wir bedauern, dass dein Eindruck nicht deinen Erwartungen entspricht. Wir möchten dein Anliegen besser verstehen. Bitte melde dich unter [Kontaktweg], damit wir es vertraulich besprechen können.',
          'Danke, dass du dir Zeit für eine Bewertung genommen hast. Wir nehmen deine Kritik ernst und würden den Vorgang gern nachvollziehen. Unter [Kontaktweg] erreichst du uns für ein persönliches Gespräch.',
        ];
  }

  if (scenario === 'positive_empty') {
    return formal
      ? [
          'Vielen Dank für Ihre Bewertung und dass Sie sich Zeit genommen haben. Wir freuen uns über Ihre Rückmeldung.',
          'Danke für Ihre Bewertung. Wir wissen es zu schätzen, dass Sie Ihre Erfahrung mit uns geteilt haben.',
        ]
      : [
          'Vielen Dank für deine Bewertung und dass du dir Zeit genommen hast. Wir freuen uns über deine Rückmeldung.',
          'Danke für deine Bewertung. Wir wissen es zu schätzen, dass du deine Erfahrung mit uns geteilt hast.',
        ];
  }

  return formal
    ? [
        'Vielen Dank für Ihre Rückmeldung. Wir freuen uns, dass Sie sich Zeit für eine Bewertung genommen haben. [Greifen Sie hier ein tatsächlich genanntes Detail auf.]',
        'Danke für Ihre freundlichen Worte. [Beziehen Sie sich hier auf einen konkreten Punkt aus der Rezension.] Ihr Feedback geben wir gern an unser Team weiter.',
      ]
    : [
        'Vielen Dank für deine Rückmeldung. Wir freuen uns, dass du dir Zeit für eine Bewertung genommen hast. [Greife hier ein tatsächlich genanntes Detail auf.]',
        'Danke für deine freundlichen Worte. [Beziehe dich hier auf einen konkreten Punkt aus der Rezension.] Dein Feedback geben wir gern an unser Team weiter.',
      ];
}

function initAssistant(root) {
  const scenario = root.querySelector('[data-fb-review-scenario]');
  const voice = root.querySelector('[data-fb-review-voice]');
  const sector = root.querySelector('[data-fb-review-sector]');
  const fields = [...root.querySelectorAll('[data-fb-review-result]')];
  const status = root.querySelector('[data-fb-review-status]');

  root.querySelector('[data-fb-review-generate]')?.addEventListener('click', () => {
    const suggestions = responseSuggestions(scenario.value, voice.value, sector.value);
    fields.forEach((field, index) => { field.value = suggestions[index]; });
    status.textContent = 'Zwei bearbeitbare Vorschläge sind bereit.';
  });

  root.querySelectorAll('[data-fb-review-copy]').forEach((button) => {
    button.addEventListener('click', async () => {
      const field = fields[Number(button.dataset.fbReviewCopy)];
      if (!field) return;
      try {
        await navigator.clipboard.writeText(field.value);
        status.textContent = 'Text kopiert. Bitte vor dem Veröffentlichen prüfen.';
      } catch {
        field.focus();
        field.select();
        status.textContent = 'Kopieren nicht möglich. Der Text ist markiert und kann manuell kopiert werden.';
      }
    });
  });
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-fb-review-assistant]').forEach(initAssistant);
}
